import { useEffect } from "react";

export function useUpdateBreadcrumbs(title: string) {
  useEffect(() => {
    document.querySelectorAll(".CMSBreadCrumbsCurrentItem").forEach((el) => {
      el.textContent = title;
    });
  }, [title]);
}
